import produce from 'immer';
import { set, isEmpty, get } from 'lodash';
import {
  treeBuilder,
  checkAllNested,
  checkAllParents,
  unCheckIfAllUnchecked,
  setCard,
  setTree,
  emptyCard,
  handleContagem,
  countAllNested,
  countAllParents,
  setCardContagem,
} from '../../utils/treeViewBuilder';

import { getOccurrence, toJsonFromBase64 } from '../../utils/array';
import { TipoConsultaParametrizacaoEnum } from '../../enums';

// Action types
export const Types = {
  GET_GRUPO_COMPLEMENTOS_REQUEST:
    '@contratantes/GET_GRUPO_COMPLEMENTOS_REQUEST',
  GET_GRUPO_COMPLEMENTOS_SUCCESS:
    '@contratantes/GET_GRUPO_COMPLEMENTOS_SUCCESS',
  GET_GRUPO_COMPLEMENTOS_ERROR: '@contratantes/GET_GRUPO_COMPLEMENTOS_ERROR',
  GET_CONTRATANTES_REQUEST: '@contratantes/GET_CONTRATANTES_REQUEST',
  GET_CONTRATANTES_SUCCESS: '@contratantes/GET_CONTRATANTES_SUCCESS',
  GET_CONTRATANTES_ERROR: '@contratantes/GET_CONTRATANTES_ERROR',
  GET_GRUPO_CONTRATANTES_REQUEST:
    '@contratantes/GET_GRUPO_CONTRATANTES_REQUEST',
  GET_GRUPO_CONTRATANTES_SUCCESS:
    '@contratantes/GET_GRUPO_CONTRATANTES_SUCCESS',
  GET_GRUPO_CONTRATANTES_ERROR: '@contratantes/GET_GRUPO_CONTRATANTES_ERROR',
  GET_CONTRATANTE_MODALIDADES_REQUEST:
    '@contratantes/GET_CONTRATANTE_MODALIDADES_REQUEST',
  GET_CONTRATANTE_MODALIDADES_SUCCESS:
    '@contratantes/GET_CONTRATANTE_MODALIDADES_SUCCESS',
  GET_CONTRATANTE_MODALIDADES_ERROR:
    '@contratantes/GET_CONTRATANTE_MODALIDADES_ERROR',
  GET_MODALIDADE_TERMOS_REQUEST: '@contratantes/GET_MODALIDADE_TERMOS_REQUEST',
  GET_MODALIDADE_TERMOS_SUCCESS: '@contratantes/GET_MODALIDADE_TERMOS_SUCCESS',
  GET_MODALIDADE_TERMOS_ERROR: '@contratantes/GET_MODALIDADE_TERMOS_ERROR',
  GET_GRUPO_CONTAGEM_REQUEST: '@contratantes/GET_GRUPO_CONTAGEM_REQUEST',
  GET_GRUPO_CONTAGEM_SUCCESS: '@contratantes/GET_GRUPO_CONTAGEM_SUCCESS',
  GET_GRUPO_CONTAGEM_ERROR: '@contratantes/GET_GRUPO_CONTAGEM_ERROR',
  GET_CONTRATANTE_CONTAGEM_REQUEST:
    '@contratantes/GET_CONTRATANTE_CONTAGEM_REQUEST',
  GET_CONTRATANTE_CONTAGEM_SUCCESS:
    '@contratantes/GET_CONTRATANTE_CONTAGEM_SUCCESS',
  GET_CONTRATANTE_CONTAGEM_ERROR:
    '@contratantes/GET_CONTRATANTE_CONTAGEM_ERROR',
  PARAMETRIZACAO_TOOGGLE_CARD: '@contratantes/PARAMETRIZACAO_TOOGGLE_CARD',
  PARAMETRIZACAO_GET_OPTIONS: '@contratantes/PARAMETRIZACAO_GET_OPTIONS',
  PARAMETRIZACAO_SET: '@contratantes/PARAMETRIZACAO_SET',
  PARAMETRIZACAO_SET_CARDS: '@contratantes/PARAMETRIZACAO_SET_CARDS',
  PARAMETRIZACAO_SET_CARDS_BY_ID:
    '@contratantes/PARAMETRIZACAO_SET_CARDS_BY_ID',
  PARAMETRIZACAO_DELETE_CARD: '@contratantes/PARAMETRIZACAO_DELETE_CARD',
  PARAMETRIZACAO_SET_PATH: '@contratantes/PARAMETRIZACAO_SET_PATH',
  PARAMETRIZACAO_SET_SELECTED_OPTION:
    '@contratantes/PARAMETRIZACAO_SET_SELECTED_OPTION',
  PARAMETRIZACAO_ROOT_RENEW: '@contratantes/PARAMETRIZACAO_ROOT_RENEW',
  PARAMETRIZACAO_SET_LOADING: '@contratantes/PARAMETRIZACAO_SET_LOADING',
  PARAMETRIZACAO_SET_LOADING_CARDS:
    '@contratantes/PARAMETRIZACAO_SET_LOADING_CARDS',
  PARAMETRIZACAO_SET_CARD_COMPLETO:
    '@contratantes/PARAMETRIZACAO_SET_CARD_COMPLETO',
  PARAMETRIZACAO_UPDATE_ID: '@contratantes/PARAMETRIZACAO_UPDATE_ID',
  PARAMETRIZACAO_SET_ID: '@contratantes/PARAMETRIZACAO_SET_ID',
  PARAMETRIZACAO_SET_CARDS_COMPLETO:
    '@contratantes/PARAMETRIZACAO_SET_CARDS_COMPLETO',
  PARAMETRIZACAO_SET_CONTAGEM: '@contratantes/PARAMETRIZACAO_SET_CONTAGEM',
  PARAMETRIZACAO_SET_CARDS_COMPLETO_NEW_CARD:
    '@contratantes/PARAMETRIZACAO_SET_CARDS_COMPLETO_NEW_CARD',
  GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_REQUEST:
    '@contratantes/GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_REQUEST',
  GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_SUCCESS:
    '@contratantes/GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_SUCCESS',
  GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_ERROR:
    '@contratantes/GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_ERROR',
  GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_REQUEST:
    '@contratantes/GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_REQUEST',
  GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_SUCCESS:
    '@contratantes/GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_SUCCESS',
  GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_ERROR:
    '@contratantes/GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_ERROR',
};

const INITIAL_STATE = {
  getGrupoComplementos: {
    loading: false,
    success: false,
    response: {
      data: [],
      size: 0,
    },
    unsuccessResponse: null,
    error: null,
  },
  getContratantes: {
    loading: false,
    success: false,
    response: {
      data: [],
      size: 0,
    },
    unsuccessResponse: null,
    error: null,
  },
  getGrupoContratantes: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getContratanteModalidades: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getModalidadeTermos: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getGrupoContagem: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  getContratanteContagem: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: null,
    error: null,
    isError: false,
  },
  parametrizacaoRoot: [],
};

export default function contratante(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.GET_GRUPO_COMPLEMENTOS_REQUEST: {
        draft.getGrupoComplementos.loading = true;
        draft.getGrupoComplementos.success = false;
        draft.getGrupoComplementos.error = null;
        draft.getGrupoComplementos.unsuccessResponse = null;
        break;
      }
      case Types.GET_GRUPO_COMPLEMENTOS_SUCCESS: {
        draft.getGrupoComplementos.loading = false;
        draft.getGrupoComplementos.success = action.payload.isSuccess;
        draft.getGrupoComplementos.response.data =
          action.payload.grupoComplementos;
        draft.getGrupoComplementos.response.size =
          action.payload.grupoComplementos?.total;
        break;
      }
      case Types.GET_GRUPO_COMPLEMENTOS_ERROR: {
        draft.getGrupoComplementos.loading = false;
        draft.getGrupoComplementos.error = action.payload.error;
        draft.getGrupoComplementos.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.GET_CONTRATANTES_REQUEST: {
        draft.getContratantes.loading = true;
        draft.getContratantes.success = false;
        draft.getContratantes.error = null;
        draft.getContratantes.unsuccessResponse = null;
        break;
      }
      case Types.GET_CONTRATANTES_SUCCESS: {
        draft.getContratantes.loading = false;
        draft.getContratantes.success = action.payload.isSuccess;
        draft.getContratantes.response.data = action.payload.contratantes;
        draft.getContratantes.response.size = action.payload.contratantes.total;
        break;
      }
      case Types.GET_CONTRATANTES_ERROR: {
        draft.getContratantes.loading = false;
        draft.getContratantes.error = action.payload.error;
        draft.getContratantes.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.GET_GRUPO_CONTRATANTES_REQUEST: {
        draft.getGrupoContratantes.loading = true;
        draft.getGrupoContratantes.success = false;
        draft.getGrupoContratantes.error = null;
        draft.getGrupoContratantes.unsuccessResponse = null;
        break;
      }
      case Types.GET_GRUPO_CONTRATANTES_SUCCESS: {
        draft.getGrupoContratantes.loading = false;
        draft.getGrupoContratantes.success = action.payload.isSuccess;
        draft.getGrupoContratantes.response = action.payload.grupoContratantes;
        const cardAtual = draft.parametrizacaoRoot.find(
          (card) => card.idCard === action.payload.grupoContratantes.idCard
        );
        cardAtual.nodeLoading = false;

        if (action.payload.grupoContratantes.contratanteNode.length > 0) {
          const newTree = setTree(
            action.payload.grupoContratantes.contratanteNode,
            0,
            cardAtual,
            action.payload.grupoContratantes.checkAll,
            0,
            action.payload.grupoContratantes.path,
            action.payload.grupoContratantes.isSuccess
          );
          set(
            cardAtual.options,
            action.payload.grupoContratantes.path,
            ...newTree
          );
        } else {
          cardAtual.options.push(
            emptyCard('Não foram encontradas contratantes.')
          );
        }

        // if (
        //   get(cardAtual.options, action.payload.grupoContratantes.path)
        // )
        //   get(
        //     cardAtual.options,
        //     action.payload.grupoContratantes.path
        //   ).hasSubOptions = false;
        break;
      }
      case Types.GET_GRUPO_CONTRATANTES_ERROR: {
        draft.getGrupoContratantes.loading = false;
        draft.getGrupoContratantes.error = action.payload.error;
        draft.getGrupoContratantes.unsuccessResponse =
          action.payload.unsuccessResponse;
        const cardAtual = draft.parametrizacaoRoot.find(
          (card) => card.idCard === action.payload.idCard
        );
        cardAtual.nodeLoading = false;
        break;
      }
      case Types.GET_CONTRATANTE_MODALIDADES_REQUEST: {
        draft.getContratanteModalidades.loading = true;
        draft.getContratanteModalidades.success = false;
        draft.getContratanteModalidades.error = null;
        draft.getContratanteModalidades.unsuccessResponse = null;
        break;
      }
      case Types.GET_CONTRATANTE_MODALIDADES_SUCCESS: {
        draft.getContratanteModalidades.loading = false;
        draft.getContratanteModalidades.success = action.payload.isSuccess;
        draft.getContratanteModalidades.response =
          action.payload.contratanteModalidades;

        const cardAtual = draft.parametrizacaoRoot.find(
          (card) => card.idCard === action.payload.contratanteModalidades.idCard
        );
        cardAtual.nodeLoading = false;
        if (action.payload.contratanteModalidades.modalidadeNode?.length > 0) {
          const newTree = setTree(
            action.payload.contratanteModalidades.modalidadeNode,
            1,
            cardAtual,
            action.payload.contratanteModalidades.checkAll,
            action.payload.contratanteModalidades.codigoContratante,
            action.payload.contratanteModalidades.path,
            true
          );
          if (
            cardAtual.tipoParametrizacao ===
            TipoConsultaParametrizacaoEnum.returnName[1]
          ) {
            set(
              cardAtual.options,
              action.payload.contratanteModalidades.path,
              newTree
            );
          } else {
            set(
              cardAtual.options,
              action.payload.contratanteModalidades.path,
              ...newTree
            );
          }
        } else {
          cardAtual.options.push(
            emptyCard('Não foram encontradas modalidades.')
          );
        }
        break;
      }
      case Types.GET_CONTRATANTE_MODALIDADES_ERROR: {
        draft.getContratanteModalidades.loading = false;
        draft.getContratanteModalidades.error = action.payload.error;
        draft.getContratanteModalidades.unsuccessResponse =
          action.payload.unsuccessResponse;
        const cardAtual = draft.parametrizacaoRoot.find(
          (card) => card.idCard === action.payload.idCard
        );
        cardAtual.nodeLoading = false;
        break;
      }
      case Types.GET_MODALIDADE_TERMOS_REQUEST: {
        draft.getModalidadeTermos.loading = true;
        draft.getModalidadeTermos.success = false;
        draft.getModalidadeTermos.error = null;
        draft.getModalidadeTermos.unsuccessResponse = null;
        break;
      }
      case Types.GET_MODALIDADE_TERMOS_SUCCESS: {
        draft.getModalidadeTermos.loading = false;
        draft.getModalidadeTermos.success = action.payload.isSuccess;
        draft.getModalidadeTermos.response = action.payload.modalidadeTermos;
        const cardAtual = draft.parametrizacaoRoot.find(
          (card) => card.idCard === action.payload.modalidadeTermos.idCard
        );
        cardAtual.nodeLoading = false;
        if (action.payload.modalidadeTermos.termoNode.length > 0) {
          const newTree = setTree(
            action.payload.modalidadeTermos.termoNode,
            2,
            cardAtual,
            action.payload.modalidadeTermos.checkAll,
            0,
            action.payload.modalidadeTermos.path,
            true
          );
          set(cardAtual.options, action.payload.modalidadeTermos.path, newTree);
          set(
            cardAtual.options,
            [...action.payload.modalidadeTermos.path, 'success'],
            true
          );
        } else {
          get(
            cardAtual.options,
            action.payload.modalidadeTermos.currentPath
          ).hasSubOptions = false;
        }
        break;
      }
      case Types.GET_MODALIDADE_TERMOS_ERROR: {
        const cardAtual = draft.parametrizacaoRoot.find(
          (card) => card.idCard === action.payload.modalidadeTermos.idCard
        );
        cardAtual.nodeLoading = false;
        draft.getModalidadeTermos.loading = false;
        draft.getModalidadeTermos.error = action.payload.error;
        draft.getModalidadeTermos.unsuccessResponse =
          action.payload.unsuccessResponse;
        break;
      }
      case Types.GET_GRUPO_CONTAGEM_REQUEST: {
        draft.getGrupoContagem.loading = true;
        draft.getGrupoContagem.success = false;
        draft.getGrupoContagem.error = null;
        draft.getGrupoContagem.unsuccessResponse = null;
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.cards.find(
            (card) => p.idCard === card.idCard
          );
          if (card) p.cardLoading = true;
        });

        break;
      }
      case Types.GET_GRUPO_CONTAGEM_SUCCESS: {
        draft.getGrupoContagem.loading = false;
        draft.getGrupoContagem.success = action.payload.isSuccess;
        draft.getGrupoContagem.response = action.payload.response;
        // draft.parametrizacaoRoot = draft.parametrizacaoRoot.map((card) => {
        //   if (card.idCard === action.payload.response.idCard)
        //     card.contagem = {
        //       contratantes: action.payload.response.contratante,
        //       modalidades: action.payload.response.modalidade,
        //       termos: action.payload.response.termo,
        //     };
        //   return card;
        // });
        draft.parametrizacaoRoot.forEach((c) => {
          const card = action.payload.response.find(
            (r) => c.idCard === r.idCard
          );
          if (card) {
            c.contagem = {
              contratantes: card.contagem.totalContratantes,
              modalidades: card.contagem.totalModalidades,
              termos: card.contagem.totalTermos,
            };
          }
          c.cardLoading = false;
        });
        break;
      }
      case Types.GET_GRUPO_CONTAGEM_ERROR: {
        draft.getGrupoContagem.loading = false;
        draft.getGrupoContagem.error = action.payload.error;
        draft.getGrupoContagem.unsuccessResponse =
          action.payload.unsuccessResponse;
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.cards.find(
            (card) => p.idCard === card.idCard
          );
          if (card) p.cardLoading = false;
        });
        break;
      }
      case Types.GET_CONTRATANTE_CONTAGEM_REQUEST: {
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.cards.find(
            (card) => p.idCard === card.idCard
          );
          if (card) p.cardLoading = true;
        });
        draft.getContratanteContagem.loading = true;
        draft.getContratanteContagem.success = false;
        draft.getContratanteContagem.error = null;
        draft.getContratanteContagem.unsuccessResponse = null;
        break;
      }
      case Types.GET_CONTRATANTE_CONTAGEM_SUCCESS: {
        draft.getContratanteContagem.loading = false;
        draft.getContratanteContagem.success = action.payload.isSuccess;
        draft.getContratanteContagem.response = action.payload.response;

        // draft.parametrizacaoRoot = draft.parametrizacaoRoot.map((card) => {
        //   if (card.idCard === action.payload.response.idCard)
        //     card.contagem = {
        //       modalidades: action.payload.response.modalidade,
        //       termos: action.payload.response.termo,
        //     };
        //   return card;
        // });
        draft.parametrizacaoRoot.forEach((c) => {
          const card = action.payload.response.find(
            (r) => c.idCard === r.idCard
          );
          if (card) {
            c.contagem = {
              modalidades: card.contagem.totalModalidades,
              termos: card.contagem.totalTermos,
            };
          }
          c.cardLoading = false;
        });
        break;
      }
      case Types.GET_CONTRATANTE_CONTAGEM_ERROR: {
        draft.getContratanteContagem.loading = false;
        draft.getContratanteContagem.error = action.payload.error;
        draft.getContratanteContagem.unsuccessResponse =
          action.payload.unsuccessResponse;
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.cards.find(
            (card) => p.idCard === card.idCard
          );
          if (card) p.cardLoading = false;
        });
        break;
      }
      case Types.PARAMETRIZACAO_TOOGGLE_CARD: {
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.cardIds.find(
            (c) =>
              c.idCard === p.idCard ||
              c.newIdParametrizacao === p.idParametrizacao
          );
          if (card) {
            p.isEditar = action.payload.isSaveAll ? false : !p.isEditar;
            p.contagem = handleContagem(p);
          }
        });

        break;
      }
      case Types.PARAMETRIZACAO_SET: {
        draft.parametrizacaoRoot = draft.parametrizacaoRoot.map((card) => {
          if (card?.idCard === action.payload.idCard) {
            card.options = action.payload.options;
            card.selectedOptions = action.payload.selectedOptions;
            card.idCard = action.payload.idCard;
          }
        });
        break;
      }
      case Types.PARAMETRIZACAO_SET_CARDS: {
        draft.parametrizacaoRoot = [
          ...draft.parametrizacaoRoot,
          ...action.payload.rowsChecked,
        ];
        break;
      }
      case Types.PARAMETRIZACAO_SET_CARDS_BY_ID: {
        action.payload.cards.map((a) => {
          draft.parametrizacaoRoot.push(setCard(a));
        });
        break;
      }
      case Types.PARAMETRIZACAO_DELETE_CARD: {
        draft.parametrizacaoRoot = draft.parametrizacaoRoot.filter(
          (card) => card.idCard !== action.payload.idCard
        );
        break;
      }
      case Types.PARAMETRIZACAO_SET_PATH: {
        draft.parametrizacaoRoot.find(
          (card) => card.idCard === action.payload.idCard
        ).path = action.payload.pathName;
        break;
      }
      case Types.PARAMETRIZACAO_SET_SELECTED_OPTION: {
        const cardAtual = draft.parametrizacaoRoot.find(
          (card) => card.idCard === action.payload.idCard
        );
        get(cardAtual.options, action.payload.currentPath).check =
          action.payload.check;

        if (action.payload.check)
          checkAllParents(
            cardAtual.options,
            action.payload.check,
            action.payload.currentPath
          );

        // if (
        //   action.payload.isHeader ||
        //   (!action.payload.isHeader && !action.payload.check)
        // )
        checkAllNested(
          get(cardAtual.options, action.payload.currentPath),
          action.payload.check
        );

        if (!action.payload.isHeader) {
          get(
            cardAtual.options,
            action.payload.previousPath.slice(
              0,
              action.payload.previousPath.length - 1
            )
          ).count = getOccurrence(
            get(cardAtual.options, action.payload.previousPath),
            (o) => o.check === true
          );

          unCheckIfAllUnchecked(
            cardAtual.options,
            action.payload.currentPath,
            get(
              cardAtual.options,
              action.payload.currentPath.slice(
                0,
                action.payload.currentPath.length - 2
              )
            ).count
          );
        }
        // getCountInHeader(
        //   cardAtual.options,
        //   action.payload.check,
        //   action.payload.currentPath
        // );
        countAllNested(get(cardAtual.options, action.payload.currentPath));
        countAllParents(cardAtual.options, action.payload.currentPath);
        break;
      }
      case Types.PARAMETRIZACAO_ROOT_RENEW: {
        draft.parametrizacaoRoot = [];
        break;
      }
      case Types.PARAMETRIZACAO_SET_LOADING: {
        const cardAtual = draft.parametrizacaoRoot.find(
          (card) => card.idCard === action.payload.idCard
        );
        cardAtual.nodeLoading = action.payload.loading;
        break;
      }
      case Types.PARAMETRIZACAO_SET_LOADING_CARDS: {
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.cards.find((c) => p.idCard === c.idCard);

          if (card) p.cardLoading = action.payload.loading;
        });
        break;
      }
      case Types.PARAMETRIZACAO_SET_CARD_COMPLETO: {
        const cardAtual = draft.parametrizacaoRoot.find(
          (card) => card.idCard === action.payload.idCard
        );
        if (cardAtual) {
          cardAtual.options = treeBuilder(action.payload.response);
          cardAtual.fullTree = true;
        }

        break;
      }
      case Types.PARAMETRIZACAO_SET_CARDS_COMPLETO: {
        draft.parametrizacaoRoot.forEach((c) => {
          const card = action.payload.isParametrizacaoEspelho
            ? action.payload.newCards.find(
                (r) =>
                  c?.id === r?.Card?.codigoComplemento ||
                  c?.id === r?.Card?.codigoContratante
              )
            : action.payload.newCards.find(
                (r) => c.idParametrizacao === r.Card.idParametrizacao
              );
          if (card) {
            c.options = treeBuilder(card.Tree);
            c.fullTree = true;
            c.listaContratantes = card.Tree.contratanteNode.map(
              (c) => c.codigoContratante
            );
          }
        });

        break;
      }
      case Types.PARAMETRIZACAO_SET_CARDS_COMPLETO_NEW_CARD: {
        draft.parametrizacaoRoot.forEach((c) => {
          const card = action.payload.newCards.find(
            (r) => c.idCard === r.idCard
          );
          if (card) {
            c.options = treeBuilder(card.Tree);
            c.fullTree = true;
            c.listaContratantes = card.Tree.contratanteNode.map(
              (c) => c.codigoContratante
            );
            c.contagem = card.contagem;
          }
        });

        break;
      }
      case Types.PARAMETRIZACAO_UPDATE_ID: {
        draft.parametrizacaoRoot.forEach((c) => {
          const card = action.payload.newCards.find(
            (r) => c.idParametrizacao === r.oldIdParametrizacao
          );
          if (card) c.idParametrizacao = card.newIdParametrizacao;
        });

        break;
      }
      case Types.PARAMETRIZACAO_SET_ID: {
        draft.parametrizacaoRoot.forEach((c) => {
          const card = action.payload.newCards.find(
            (r) =>
              c.idParametrizacao === r.oldIdParametrizacao &&
              c.idCard === r.idCard
          );
          if (card) c.idParametrizacao = card.newIdParametrizacao;
        });

        break;
      }
      case Types.PARAMETRIZACAO_SET_CONTAGEM: {
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.contagemCards.find(
            (c) => c.idParametrizacao === p.idParametrizacao
          );

          if (card) p.contagem = setCardContagem(card.tipoParametrizacao, card);
        });

        break;
      }
      case Types.GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_REQUEST: {
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.params.find(
            (card) => p.idCard === card.idCard
          );
          if (card) p.cardLoading = true;
        });
        break;
      }
      case Types.GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_SUCCESS: {
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.params.find(
            (card) => p.idCard === card.idCard
          );
          if (card) p.cardLoading = false;
        });
        break;
      }
      case Types.GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_ERROR: {
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.params.find(
            (card) => p.idCard === card.idCard
          );
          if (card) p.cardLoading = false;
        });
        break;
      }
      case Types.GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_REQUEST: {
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.params.find(
            (card) => p.idCard === card.idCard
          );
          if (card) p.cardLoading = true;
        });
        break;
      }
      case Types.GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_SUCCESS: {
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.params.find(
            (card) => p.idCard === card.idCard
          );
          if (card) {
            p.cardLoading = false;
          }
        });
        break;
      }
      case Types.GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_ERROR: {
        draft.parametrizacaoRoot.forEach((p) => {
          const card = action.payload.params.find(
            (card) => p.idCard === card.idCard
          );
          if (card) p.cardLoading = false;
        });
        break;
      }
      default:
    }
  });
}

export const Creators = {
  getGrupoComplementosRequest: (params) => ({
    type: Types.GET_GRUPO_COMPLEMENTOS_REQUEST,
    payload: { params },
  }),
  getGrupoComplementosSuccess: (grupoComplementos, isSuccess) => ({
    type: Types.GET_GRUPO_COMPLEMENTOS_SUCCESS,
    payload: { grupoComplementos, isSuccess },
  }),
  getGrupoComplementosError: (unsuccessResponse, error) => ({
    type: Types.GET_GRUPO_COMPLEMENTOS_ERROR,
    payload: { unsuccessResponse, error },
  }),
  getContratanteRequest: (params) => ({
    type: Types.GET_CONTRATANTES_REQUEST,
    payload: { params },
  }),
  getContratanteSuccess: (contratantes, isSuccess) => ({
    type: Types.GET_CONTRATANTES_SUCCESS,
    payload: { contratantes, isSuccess },
  }),
  getContratanteError: (unsuccessResponse, error) => ({
    type: Types.GET_CONTRATANTES_ERROR,
    payload: { unsuccessResponse, error },
  }),
  getGrupoContratantesRequest: (params) => ({
    type: Types.GET_GRUPO_CONTRATANTES_REQUEST,
    payload: { params },
  }),
  getGrupoContratantesSuccess: (grupoContratantes, isSuccess) => ({
    type: Types.GET_GRUPO_CONTRATANTES_SUCCESS,
    payload: { grupoContratantes, isSuccess },
  }),
  getGrupoContratantesError: (unsuccessResponse, error, idCard) => ({
    type: Types.GET_GRUPO_CONTRATANTES_ERROR,
    payload: { unsuccessResponse, error, idCard },
  }),
  getContratanteModalidadesRequest: (params) => ({
    type: Types.GET_CONTRATANTE_MODALIDADES_REQUEST,
    payload: { params },
  }),
  getContratanteModalidadesSuccess: (contratanteModalidades, isSuccess) => ({
    type: Types.GET_CONTRATANTE_MODALIDADES_SUCCESS,
    payload: { contratanteModalidades, isSuccess },
  }),
  getContratanteModalidadesError: (unsuccessResponse, error, idCard) => ({
    type: Types.GET_CONTRATANTE_MODALIDADES_ERROR,
    payload: { unsuccessResponse, error, idCard },
  }),
  getModalidadeTermosRequest: (params) => ({
    type: Types.GET_MODALIDADE_TERMOS_REQUEST,
    payload: { params },
  }),
  getModalidadeTermosSuccess: (modalidadeTermos, isSuccess) => ({
    type: Types.GET_MODALIDADE_TERMOS_SUCCESS,
    payload: { modalidadeTermos, isSuccess },
  }),
  getModalidadeTermosError: (unsuccessResponse, error, idCard) => ({
    type: Types.GET_MODALIDADE_TERMOS_ERROR,
    payload: { unsuccessResponse, error, idCard },
  }),
  getGrupoContagemRequest: (cards) => ({
    type: Types.GET_GRUPO_CONTAGEM_REQUEST,
    payload: { cards },
  }),
  getGrupoContagemSuccess: (response, isSuccess, cards) => ({
    type: Types.GET_GRUPO_CONTAGEM_SUCCESS,
    payload: { response, isSuccess },
  }),
  getGrupoContagemError: (unsuccessResponse, error, cards) => ({
    type: Types.GET_GRUPO_CONTAGEM_ERROR,
    payload: { unsuccessResponse, error },
  }),
  getContratanteContagemRequest: (cards) => ({
    type: Types.GET_CONTRATANTE_CONTAGEM_REQUEST,
    payload: { cards },
  }),
  getContratanteContagemSuccess: (response, isSuccess, cards) => ({
    type: Types.GET_CONTRATANTE_CONTAGEM_SUCCESS,
    payload: { response, isSuccess },
  }),
  getContratanteContagemError: (unsuccessResponse, error, cards) => ({
    type: Types.GET_CONTRATANTE_CONTAGEM_ERROR,
    payload: { unsuccessResponse, error },
  }),
  parametrizacaoToogleCard: (cardIds, isSaveAll = false) => ({
    type: Types.PARAMETRIZACAO_TOOGGLE_CARD,
    payload: { cardIds, isSaveAll },
  }),
  parametrizacaoSet: (options, selectedOptions, idCard) => ({
    type: Types.PARAMETRIZACAO_SET,
    payload: { options, selectedOptions, idCard },
  }),
  parametrizacaoSetCards: (rowsChecked) => ({
    type: Types.PARAMETRIZACAO_SET_CARDS,
    payload: { rowsChecked },
  }),
  parametrizacaoSetCardsById: (cards) => ({
    type: Types.PARAMETRIZACAO_SET_CARDS_BY_ID,
    payload: { cards },
  }),
  parametrizacaoDeleteCard: (idCard) => ({
    type: Types.PARAMETRIZACAO_DELETE_CARD,
    payload: { idCard },
  }),
  parametrizacaoSetPath: (pathName, idCard) => ({
    type: Types.PARAMETRIZACAO_SET_PATH,
    payload: { pathName, idCard },
  }),
  parametrizacaoSetSelectedOption: (
    currentPath,
    idCard,
    check,
    isHeader,
    id,
    previousPath
  ) => ({
    type: Types.PARAMETRIZACAO_SET_SELECTED_OPTION,
    payload: { currentPath, idCard, check, isHeader, id, previousPath },
  }),
  parametrizacaoRootRenew: () => ({
    type: Types.PARAMETRIZACAO_ROOT_RENEW,
  }),
  parametrizacaoSetLoading: (loading, idCard) => ({
    type: Types.PARAMETRIZACAO_SET_LOADING,
    payload: { loading, idCard },
  }),
  parametrizacaoSetLoadingCards: (loading, cards) => ({
    type: Types.PARAMETRIZACAO_SET_LOADING_CARDS,
    payload: { loading, cards },
  }),
  parametrizacaoSetCardCompleto: (response, idCard) => ({
    type: Types.PARAMETRIZACAO_SET_CARD_COMPLETO,
    payload: { response, idCard },
  }),
  parametrizacaoUpdateId: (newCards) => ({
    type: Types.PARAMETRIZACAO_UPDATE_ID,
    payload: { newCards },
  }),
  parametrizacaoSetId: (newCards) => ({
    type: Types.PARAMETRIZACAO_SET_ID,
    payload: { newCards },
  }),
  parametrizacaoSetCardsCompleto: (
    newCards,
    isParametrizacaoEspelho = false
  ) => ({
    type: Types.PARAMETRIZACAO_SET_CARDS_COMPLETO,
    payload: { newCards, isParametrizacaoEspelho },
  }),
  parametrizacaoSetContagem: (contagemCards) => ({
    type: Types.PARAMETRIZACAO_SET_CONTAGEM,
    payload: { contagemCards },
  }),
  parametrizacaoSetCardsCompletoNewCards: (newCards) => ({
    type: Types.PARAMETRIZACAO_SET_CARDS_COMPLETO_NEW_CARD,
    payload: { newCards },
  }),
  getParametrizacaoGrupoComplementoCompletoRequest: (params) => ({
    type: Types.GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_REQUEST,
    payload: { params },
  }),
  getParametrizacaoGrupoComplementoCompletoSuccess: (
    isSuccess,
    response,
    params
  ) => ({
    type: Types.GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_SUCCESS,
    payload: { isSuccess, response, params },
  }),
  getParametrizacaoGrupoComplementoCompletoError: (error, params) => ({
    type: Types.GET_PARAMETRIZACAO_GRUPO_COMPLEMENTO_COMPLETO_ERROR,
    payload: { error, params },
  }),
  getParametrizacaoContratanteCompletoRequest: (params) => ({
    type: Types.GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_REQUEST,
    payload: { params },
  }),
  getParametrizacaoContratanteCompletoSuccess: (
    isSuccess,
    response,
    params
  ) => ({
    type: Types.GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_SUCCESS,
    payload: { isSuccess, response, params },
  }),
  getParametrizacaoContratanteCompletoError: (error, params) => ({
    type: Types.GET_PARAMETRIZACAO_CONTRATANTE_COMPLETO_ERROR,
    payload: { error, params },
  }),
};
